import CustomElement from '~utilities/custom-element';

class ELearning extends CustomElement {
	constructor() {
		super();
	}


	callback() {
		super.callback();
		const ctaButton = document.getElementById('start');
		const closeButton = document.getElementsByClassName(['cta--close'])[0];
		const eLearningFrame = document.getElementsByClassName(['elearning__iframe'])[0];

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				closeButton.click()
			}

		});


		document.getElementById('start').addEventListener("click", () => {
			eLearningFrame.style.display = 'block'
			eLearningFrame.focus()

			console.log('is expanded? ', ctaButton.getAttribute('aria-expanded'))

			const isExpanded = ctaButton.getAttribute('aria-expanded') == "false"
			ctaButton.setAttribute("aria-expanded", isExpanded)

			var codes = [
				...document.querySelectorAll('a'),
				...document.querySelectorAll('button')
			];

			for (var i = 0, len = codes.length; i < len; i++) {
				console.log(codes[i])
				codes[i].setAttribute('tabindex', isExpanded ? '-1' : '0');
			}

			if (isExpanded) {
				var enableMenuItems = [
					...document.querySelectorAll('.cta--button.cta--close'),
					...document.querySelectorAll('.iv-player-overlay-icon.iv-player-play-icon'),
				];

				for (var i = 0, len = enableMenuItems.length; i < len; i++) {
					console.log(enableMenuItems[i])
					enableMenuItems[i].setAttribute('tabindex', '0');
				}
			}

		})

		closeButton.addEventListener("click", () => {
			eLearningFrame.style.display = 'none'
			var codes = [
				...document.querySelectorAll('a'),
				...document.querySelectorAll('button')
			];

			for (var i = 0, len = codes.length; i < len; i++) {
				codes[i].setAttribute('tabindex', '0');
			}
		})
	}

}

export default ELearning;
